import { filter, chunk, get, set } from 'lodash';
import { Icon } from '@iconify/react';
import { sentenceCase } from 'change-case';
import { useState, useEffect, useRef, View } from 'react';
import plusFill from '@iconify/icons-eva/plus-fill';
import ArrowBack from '@iconify/icons-eva/arrow-ios-back-outline';
import FileTextOutline from '@iconify/icons-eva/file-text-outline';
import DownloadOutline from '@iconify/icons-eva/download-outline';
import { Link as RouterLink, useNavigate, useParams } from 'react-router-dom';
// material
import {
  Card,
  Table,
  Stack,
  Button,
  TableRow,
  TableBody,
  TableCell,
  Container,
  Typography,
  TableContainer,
  TablePagination,
  Box,
  Paper,
  FormControl,
  InputLabel,
  Select,
  MenuItem
} from '@mui/material';
import { makeStyles } from '@mui/styles';
import moment from 'moment';

import { saveAs } from 'file-saver';

// components
import Page from '../../components/Page';
import Label from '../../components/Label';
import Scrollbar from '../../components/Scrollbar';
import SearchNotFound from '../../components/SearchNotFound';
import { ListHead, ListToolbar, MoreMenu } from '../../components/numberofsales';
import ConfDialog from '../../components/ConfDialog';

import SaleCsvModal from './SaleCsvModal';

// ----------------------------------------------------------------------

const TABLE_HEAD = [
  { id: 'sale_dt', label: '販売日', alignRight: false },
  { id: 'distributor_code', label: '販売代理店', alignRight: false },
  { id: 'customer_code', label: '設置場所', alignRight: false },
  { id: 'device_code', label: 'デバイス', alignRight: false },
  { id: 'product_code', label: '商品', alignRight: false },
  { id: 'employee_code', label: '社員番号', alignRight: false }
];

const TABLE_HEAD_D = [
  { id: 'sale_dt', label: '販売日', alignRight: false },
  { id: 'customer_code', label: '設置場所', alignRight: false },
  { id: 'device_code', label: 'デバイス', alignRight: false },
  { id: 'product_code', label: '商品', alignRight: false },
  { id: 'employee_code', label: '社員番号', alignRight: false }
];

const TABLE_HEAD_C = [
  { id: 'sale_dt', label: '販売日', alignRight: false },
  { id: 'device_code', label: 'デバイス', alignRight: false },
  { id: 'product_code', label: '商品', alignRight: false },
  { id: 'employee_code', label: '社員番号', alignRight: false }
];

// ----------------------------------------------------------------------

function descendingComparator(a, b, orderBy) {
  if (b[orderBy] < a[orderBy]) {
    return -1;
  }
  if (b[orderBy] > a[orderBy]) {
    return 1;
  }
  return 0;
}

function getComparator(order, orderBy) {
  return order === 'desc'
    ? (a, b) => descendingComparator(a, b, orderBy)
    : (a, b) => -descendingComparator(a, b, orderBy);
}

function applySortFilter(
  array,
  comparator,
  query,
  distributorCode,
  customerCode,
  deviceCode,
  dt_s,
  dt_e
) {
  if (query) {
    array = filter(
      array,
      (_target) =>
        _target.with_product &&
        (_target.with_product.name.toLowerCase().indexOf(query.toLowerCase()) !== -1 ||
          _target.with_product.code.toLowerCase().indexOf(query.toLowerCase()) !== -1)
    );
  }
  if (distributorCode !== -1) {
    array = filter(array, (_target) => _target.distributor_code === distributorCode);
  }
  if (customerCode !== -1) {
    array = filter(array, (_target) => _target.customer_code === customerCode);
  }
  if (deviceCode !== -1) {
    array = filter(array, (_target) => _target.device_code === deviceCode);
  }
  const stabilizedThis = array.map((el, index) => [el, index]);
  stabilizedThis.sort((a, b) => {
    const order = comparator(a[0], b[0]);
    if (order !== 0) return order;
    return a[1] - b[1];
  });
  return stabilizedThis.map((el) => el[0]);
}

export default function NumberOfSales() {
  const navigate = useNavigate();
  const params = useParams();

  const { SystemLib } = window;
  const { userInfo } = SystemLib;
  const [page, setPage] = useState(0);
  const [order, setOrder] = useState('asc');
  const [selected, setSelected] = useState([]);
  const [orderBy, setOrderBy] = useState(null);
  const [filterName, setFilterName] = useState('');
  const [rowsPerPage, setRowsPerPage] = useState(50);

  const [list, setList] = useState([]);
  const [updateDt, setUpdateDt] = useState(moment().unix());

  const [isLoading, setIsLoading] = useState(false);
  const [conf, setConf] = useState(false);
  const [confAll, setConfAll] = useState(false);
  const [confOk, setConfOk] = useState(() => {});
  const diagOkproc = useRef(false);

  const [csvFile, setCsvFile] = useState(null);
  const [tableHead, setTableHead] = useState(TABLE_HEAD);

  // フィルタ用
  const [distributorCode, setDistributorCode] = useState(-1);
  const [customerCode, setCustomerCode] = useState(-1);
  const [deviceCode, setDeviceCode] = useState(-1);
  const [dt_s, setdtS] = useState(moment().format('YYYY-MM-01'));
  const [dt_e, setdtE] = useState(moment().endOf('month').format('YYYY-MM-DD'));

  const [sum_quantity, setSumQuantity] = useState(0);
  const [sum_error, setSumError] = useState(0);

  const [modalCsv, setModalCsv] = useState(false);
  const [listCsv, setListCsv] = useState([]);
  const [keyCsv, setKeyCsv] = useState('');

  const [csvImportDialogOpen, setCsvImportDialogOpen] = useState(false);

  const [filterMode, setFilterMode] = useState('all');

  useEffect(() => {
    if (userInfo) {
      if (userInfo.distributor_code) {
        setDistributorCode(userInfo.distributor_code);
      }
      if (userInfo.customer_code) {
        setCustomerCode(userInfo.customer_code);
      }
      if (userInfo.role === 'distributor_admin' || userInfo.role === 'distributor_user') {
        setTableHead(TABLE_HEAD_D);
      } else if (userInfo.role === 'customer_admin' || userInfo.role === 'customer_user') {
        setTableHead(TABLE_HEAD_C);
      }
    }
  }, []);

  useEffect(() => {
    getList();
  }, [dt_s, dt_e]);

  const handleRequestSort = (event, property) => {
    const isAsc = orderBy === property && order === 'asc';
    setOrder(isAsc ? 'desc' : 'asc');
    setOrderBy(property);
  };

  const handleSelectAllClick = (event) => {
    if (event.target.checked) {
      const newSelecteds = filteredItems.map((n) => n.id);
      setSelected(newSelecteds);
      return;
    }
    setSelected([]);
  };

  const handleChangePage = (event, newPage) => {
    setPage(newPage);
  };

  const handleChangeRowsPerPage = (event) => {
    setRowsPerPage(parseInt(event.target.value, 10));
    setPage(0);
  };

  const handleFilterByName = (event) => {
    setPage(0);
    setFilterName(event.target.value);
  };

  const emptyRows = page > 0 ? Math.max(0, (1 + page) * rowsPerPage - list.length) : 0;

  const filteredItems = applySortFilter(
    list,
    getComparator(order, orderBy),
    filterName,
    distributorCode,
    customerCode,
    deviceCode,
    dt_s,
    dt_e
  );

  const displayedItems = (() => {
    switch (filterMode) {
      case 'normal':
        // 正常な行のみ
        return filteredItems.filter((row) => row.status !== 'E');
      case 'error':
        // エラー行のみ
        return filteredItems.filter((row) => row.status === 'E');
      default:
        // すべて
        return filteredItems;
    }
  })();

  useEffect(() => {
    if (filteredItems) {
      let sum_qt = 0;
      let sum_err = 0;
      filteredItems.forEach((v) => {
        sum_qt += v.status === 'S' ? 1 : 0;
      });
      filteredItems.forEach((v) => {
        sum_err += v.status === 'E' ? 1 : 0;
      });
      setSumQuantity(sum_qt);
      setSumError(sum_err);
    }
  }, [filteredItems]);

  const isItemNotFound = filteredItems.length === 0;

  const useStyles = makeStyles({
    tableCell: {
      height: 10
    }
  });

  const getList = async () => {
    setIsLoading(true);
    const { data } = await SystemLib.api(
      'numberofsales/list',
      {
        dt_s,
        dt_e
      },
      'post'
    );
    if (data.result) {
      setList(data.data);
    }
    setIsLoading(false);
  };

  // const deleteItems = async (ids) => {
  //   const tmp = chunk(ids, 1000);
  //   const p = [];
  //   tmp.forEach(async (arr) => {
  //     console.log(arr);
  //     p.push(
  //       SystemLib.api(
  //         `stock/delete`,
  //         {
  //           ids: arr
  //         },
  //         'post'
  //       )
  //     );
  //   });
  //   await Promise.all(p);
  //   const newItems = list.filter((v) => !ids.includes(v.id));
  //   setList(newItems);
  // };

  const onFileChange = async (e) => {
    if (e.target.files) {
      setIsLoading(true);
      const { data } = await SystemLib.csvUpload('sale/csv_upload', e.target.files[0]);
      console.log(data);
      if (data.result) {
        setKeyCsv(data.data.key);
        setListCsv(data.data.list);
        setModalCsv(true);
      }
      setIsLoading(false);
    }
    e.target.value = '';
  };

  const reload = async () => {
    getList();
  };

  const getCsv = async () => {
    const res = await SystemLib.api(
      'numberofsales/csv_download',
      {
        params: {
          dt_s,
          dt_e
        },
        responseType: 'blob'
      },
      'get'
    )
      .then((res) => {
        const namePos = res.headers['content-disposition'].indexOf('=') + 1;
        const name = res.headers['content-disposition'].substring(namePos);
        const blob = new Blob([res.data], { type: res.data.type });
        saveAs(blob, name);
      })
      .catch((error) => {
        console.log(error.messagae);
      });
    console.log(res);
  };

  const onCSVImport = async () => {
    try {
      setIsLoading(true);
      // csv_import API にアクセス
      const { data } = await SystemLib.api('numberofsales/csv_import', {}, 'get');
      if (data.result) {
        // API 処理完了後、ダイアログを表示
        setCsvImportDialogOpen(true);
      } else {
        // エラーハンドリング
        console.error('CSV Import エラー', data);
      }
    } catch (error) {
      console.error('CSV Import 例外', error);
    } finally {
      getList();
      setIsLoading(false);
    }
  };

  const classes = useStyles();

  const numberWithComma = new Intl.NumberFormat();
  const quantitySumFormat = numberWithComma.format(sum_quantity);

  return (
    <>
      <Page title="販売数閲覧">
        <Container sx={{ position: 'relative' }}>
          <Stack direction="row" alignItems="center" justifyContent="flex-start" spacing={3} mb={1}>
            <Typography variant="h4">販売数閲覧</Typography>
            <Typography variant="h6" color="#2e8b57">
              総販売数：{quantitySumFormat} 個
            </Typography>
            {(userInfo.role === 'master' || userInfo.role === 'admin') && (
              <Stack
                direction="row"
                spacing={1}
                alignItems="center"
                sx={{ backgroundColor: '#f5f5f5', padding: 1, borderRadius: 1 }}
              >
                <Typography variant="body2">表示モード:</Typography>
                <FormControl variant="outlined" size="small">
                  <InputLabel id="filterMode-label">モード</InputLabel>
                  <Select
                    labelId="filterMode-label"
                    id="filterMode"
                    value={filterMode}
                    label="モード"
                    onChange={(e) => setFilterMode(e.target.value)}
                  >
                    <MenuItem value="all">すべて</MenuItem>
                    <MenuItem value="normal">正常のみ</MenuItem>
                    <MenuItem value="error">エラーのみ ({sum_error}件)</MenuItem>
                  </Select>
                </FormControl>
              </Stack>
            )}
            <Box sx={{ flexGrow: 1 }} />
            <Button
              disabled={isLoading}
              variant="outlined"
              startIcon={<Icon icon={ArrowBack} />}
              onClick={() => {
                navigate(-1);
              }}
            >
              戻る
            </Button>
            {(userInfo.role === 'master' || userInfo.role === 'admin') && (
              <Button
                disabled={isLoading}
                variant="contained"
                startIcon={<Icon icon={FileTextOutline} />}
                onClick={() => {
                  onCSVImport();
                }}
              >
                {!isLoading ? '販売数登録実行' : '処理中'}
                <input type="button" hidden onChange={(e) => onFileChange(e)} />
              </Button>
            )}
            <Button
              disabled={isLoading}
              variant="contained"
              component="label"
              startIcon={<Icon icon={DownloadOutline} />}
              onClick={() => {
                getCsv();
              }}
            >
              CSVダウンロード
            </Button>
          </Stack>
          <Card>
            <ListToolbar
              distributor_code={distributorCode}
              customer_code={customerCode}
              device_code={deviceCode}
              dtS={dt_s}
              dtE={dt_e}
              numSelected={selected.length}
              filterName={filterName}
              onFilterName={handleFilterByName}
              onDelete={() => {
                setConfAll(true);
              }}
              onChangeDistributorCode={(code) => {
                setDistributorCode(code);
              }}
              onChangeCustomerCode={(code) => {
                setCustomerCode(code);
              }}
              onChangeDeviceCode={(code) => {
                setDeviceCode(code);
              }}
              onChangeDateS={(dt) => {
                setdtS(dt);
              }}
              onChangeDateE={(dt) => {
                setdtE(dt);
              }}
            />

            <Scrollbar>
              <TableContainer sx={{ minWidth: 800, maxHeight: '80vh' }}>
                <Table stickyHeader>
                  <ListHead
                    order={order}
                    orderBy={orderBy}
                    headLabel={tableHead}
                    rowCount={filteredItems.length}
                    numSelected={selected.length}
                    onRequestSort={handleRequestSort}
                    onSelectAllClick={handleSelectAllClick}
                  />
                  <TableBody>
                    {displayedItems
                      .slice(page * rowsPerPage, page * rowsPerPage + rowsPerPage)
                      .map((row) => {
                        const {
                          id,
                          sale_dt,
                          status,
                          customer_code,
                          customer_name,
                          with_distributor,
                          with_device,
                          with_product,
                          employee_code,
                          note
                        } = row;
                        const isItemSelected = selected.indexOf(id) !== -1;
                        const numberWithComma = new Intl.NumberFormat();
                        // const priceFormat = numberWithComma.format(price);
                        return (
                          <>
                            {status === 'E' && (
                              <TableRow
                                sx={{
                                  backgroundColor: 'rgba(255, 0, 0, 0.2)'
                                }}
                              >
                                <TableCell
                                  colSpan={tableHead.length}
                                  scope="row"
                                  key={`v_note${id}`}
                                  padding="none"
                                  sx={{
                                    paddingLeft: 3,
                                    paddingTop: 1,
                                    paddingBottom: 1,
                                    paddingRight: 3,
                                    color: 'red',
                                    fontWeight: 'bold'
                                  }}
                                >
                                  {note}
                                </TableCell>
                              </TableRow>
                            )}
                            <TableRow
                              hover
                              key={id}
                              tabIndex={-1}
                              role="checkbox"
                              selected={isItemSelected}
                              aria-checked={isItemSelected}
                              sx={{
                                backgroundColor:
                                  row.status === 'E' ? 'rgba(255, 0, 0, 0.1)' : 'inherit'
                              }}
                            >
                              <TableCell scope="row" key={`sale_dt${id}`} sx={{ paddingLeft: 3 }}>
                                {moment(sale_dt).format('YYYY-MM-DD')}
                              </TableCell>
                              {(userInfo.role === 'master' || userInfo.role === 'admin') && (
                                <TableCell scope="row" key={`d_code${id}`} padding="normal">
                                  {[
                                    with_distributor?.code ?? '-',
                                    <br key={`d_code_br${id}`} />,
                                    with_distributor?.name ?? '-'
                                  ]}
                                </TableCell>
                              )}
                              {(userInfo.role === 'master' ||
                                userInfo.role === 'admin' ||
                                userInfo.role === 'distributor_admin' ||
                                userInfo.role === 'distributor_user') && (
                                <TableCell scope="row" key={`c_code${id}`} padding="normal">
                                  {[customer_code ?? '-', <br />, customer_name ?? '-']}
                                </TableCell>
                              )}
                              <TableCell scope="row" key={`v_code${id}`} padding="normal">
                                {[with_device?.code ?? '-', <br />, with_device?.name ?? '-']}
                              </TableCell>
                              <TableCell scope="row" key={`p_code${id}`} padding="normal">
                                {[with_product?.code ?? '-', <br />, with_product?.name ?? '-']}
                              </TableCell>
                              <TableCell scope="row" key={`employee_code${id}`} padding="normal">
                                {employee_code}
                              </TableCell>
                            </TableRow>
                          </>
                        );
                      })}
                    {emptyRows > 0 && (
                      <TableRow style={{ height: 53 * emptyRows }}>
                        <TableCell colSpan={9} />
                      </TableRow>
                    )}
                  </TableBody>
                  {isItemNotFound && !isLoading && (
                    <TableBody>
                      <TableRow>
                        <TableCell align="center" colSpan={9} sx={{ py: 3 }}>
                          <SearchNotFound searchQuery={filterName} />
                        </TableCell>
                      </TableRow>
                    </TableBody>
                  )}
                  {isItemNotFound && isLoading && (
                    <TableBody>
                      <TableRow>
                        <TableCell align="center" colSpan={9} sx={{ py: 3 }}>
                          <Paper>
                            <Typography gutterBottom align="center" variant="subtitle1">
                              読み込み中
                            </Typography>
                          </Paper>
                        </TableCell>
                      </TableRow>
                    </TableBody>
                  )}
                </Table>
              </TableContainer>
            </Scrollbar>

            <TablePagination
              rowsPerPageOptions={[10, 20, 30, 50, 100]}
              component="div"
              // count={filteredItems.length}
              count={displayedItems.length}
              rowsPerPage={rowsPerPage}
              page={page}
              onPageChange={handleChangePage}
              onRowsPerPageChange={handleChangeRowsPerPage}
              labelRowsPerPage="表示件数"
            />
          </Card>
        </Container>
        {modalCsv && (
          <SaleCsvModal
            open={modalCsv}
            onClose={() => {
              setModalCsv(false);
            }}
            updateDt={updateDt}
            reload={() => {
              reload();
            }}
            keycode={keyCsv}
            data={listCsv}
          />
        )}
        <ConfDialog
          open={conf}
          onOk={() => {
            if (!diagOkproc.current) {
              diagOkproc.current = true;
              confOk();
              setConf(false);
              diagOkproc.current = false;
            }
          }}
          onCancel={() => {
            setConf(false);
          }}
          onClose={() => {
            setConf(false);
          }}
        >
          実行してもよろしいでしょうか？
        </ConfDialog>
        <ConfDialog
          open={confAll}
          onOk={() => {
            if (!diagOkproc.current) {
              diagOkproc.current = true;
              confOk();
              setSelected([]);
              setConfAll(false);
              diagOkproc.current = false;
            }
          }}
          onCancel={() => {
            setConfAll(false);
          }}
          onClose={() => {
            setConfAll(false);
          }}
        >
          実行してもよろしいでしょうか？ ({selected.length}件)
        </ConfDialog>
        {/* CSV Import 完了ダイアログ */}
        <ConfDialog
          open={csvImportDialogOpen}
          onOk={() => {
            setCsvImportDialogOpen(false);
          }}
          onClose={() => {
            setCsvImportDialogOpen(false);
          }}
        >
          インポート処理が完了しました。
        </ConfDialog>
      </Page>
    </>
  );
}
